import { SHORT_TIME_WITH_TZ } from '../constants/dates';
import dateFormatter from './dateFormatter';

export default function shortTimeTimeZone(
  date: Date | string,
  timeZone?: string
): string {
  return dateFormatter(date, SHORT_TIME_WITH_TZ, timeZone);
}
